export const SIDEBAR_WIDTH = 127;
export const MAX_COLUMN_WIDTH = 299;
export const MINIMUM_NUMBER_OF_CLASSES_TO_COMPARE = 2;
export const MAX_NUMBER_OF_CLASSES_TO_COMPARE = 3;
